"use client";

import React from "react";
import { BiEnvelope, BiMap, BiPhone } from "react-icons/bi";

export function Contact18() {
  return (
    /* bg-wood-brown = tvoje hnědá, text-white = bílý text, aby to na hnědé svítilo */
    <section className="bg-wood-brown text-white font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 items-start gap-x-12 gap-y-12 md:grid-cols-3 md:gap-y-16">
          
          {/* EMAIL */}
          <div className="flex flex-col items-center text-center group">
            <div className="mb-5 lg:mb-6 p-4 bg-white/10 rounded-full shadow-sm group-hover:bg-white/20 transition-all">
              <BiEnvelope className="text-3xl text-white" />
            </div>
            <h3 className="mb-3 text-2xl font-bold font-serif leading-[1.2] md:text-3xl">
              E-mail
            </h3>
            <p className="mb-4 opacity-70">Napište nám, ozveme se zpět</p>
            <a 
              href="mailto:jiri@tesarstvi-sindelar.cz" 
              className="text-lg font-bold hover:text-wood-cream transition-colors border-b border-transparent hover:border-wood-cream"
            >
              jiri@tesarstvi-sindelar.cz
            </a>
          </div>

          {/* TELEFON */}
          <div className="flex flex-col items-center text-center group">
            <div className="mb-5 lg:mb-6 p-4 bg-white/10 rounded-full shadow-sm group-hover:bg-white/20 transition-all">
              <BiPhone className="text-3xl text-white" />
            </div>
            <h3 className="mb-3 text-2xl font-bold font-serif leading-[1.2] md:text-3xl">
              Telefon
            </h3>
            <p className="mb-4 opacity-70">Zavolejte kdykoliv</p>
            <a 
              href="tel:+420723856780" 
              className="text-lg font-bold hover:text-wood-cream transition-colors border-b border-transparent hover:border-wood-cream"
            >
              +420 723 856 780
            </a>
          </div>

          {/* SÍDLO */}
          <div className="flex flex-col items-center text-center group">
            <div className="mb-5 lg:mb-6 p-4 bg-white/10 rounded-full shadow-sm group-hover:bg-white/20 transition-all">
              <BiMap className="text-3xl text-white" />
            </div>
            <h3 className="mb-3 text-2xl font-bold font-serif leading-[1.2] md:text-3xl">
              Sídlo
            </h3>
            <p className="mb-4 opacity-70">Najdete nás zde</p>
            <span className="text-lg font-bold">
              Vilová čtvrť 176
              <br />411 45 Úštěk-Českolipské Předměstí
            </span>
          </div>

        </div>

        {/* Spodní linka s copyrightem a tvůrcem */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm opacity-60">
          <p>© 2026 Tesařství Šindelář. Všechna práva vyhrazena.</p>
          
          <p>
            Vytvořilo{" "}
            <a 
              href="https://www.studiospectro.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-bold hover:text-wood-cream transition-colors underline decoration-white/20 underline-offset-4"
            >
              Studio Spectro
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}